import { ErrorManagementError } from "./chunk-FUUCA3UI.js";
import { error_management_default, getDebugId } from "./chunk-A2YXKFQY.js";

// src/react/components/ErrorBoundary.tsx
import React from "react";
import { Fragment, jsx } from "react/jsx-runtime";
var ErrorBoundary = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: void 0
    };
  }
  componentDidCatch(error) {
    this.setState({
      error
    });
    if (error instanceof ErrorManagementError) {
      error_management_default.exception(error.event);
    } else {
      error_management_default.exception({
        exception: error
      });
    }
  }
  render() {
    const {
      children,
      as: Component
    } = this.props;
    const {
      error
    } = this.state;
    if (error) {
      return /* @__PURE__ */jsx(Component, {
        debugId: getDebugId()
      });
    }
    return /* @__PURE__ */jsx(Fragment, {
      children
    });
  }
};
export { ErrorBoundary };